<template>
  <gc-main-layout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :selectedIndex="selectedIndex"
    :baseView="baseView"
    :formsConfig="formsConfig"
    :key="baseView.mode"
    :hot-key-create-path="`/currency/create`"
    :backButtonEnable="true"
    :backButtonFunction="backButtonFunction"
  >
    <template #headerContent>
      <GcHeaderContentStatic title="Currency" />
    </template>
    <div>
      <gc-split-view
        :showLeftContainer="showLeftContainer"
        :showRightContainer="showRightContainer"
      >
        <template #leftContent>
          <div>
            <gc-filter-split-view
              :showLeftContainer="showFilterLeftContainer"
              :showRightContainer="showFilterRightContainer"
            >
              <template #leftContent>
                <dx-data-grid
                  :data-source="dataSourceConfig"
                  :columns="columns"
                  :height="gridHeight"
                  @cell-click="onRowClicked($event, rowSelect)"
                  @toolbar-preparing="onToolbarPreparing($event)"
                  @context-menu-preparing="
                    onContextMenuPreparing($event, rowSelect)
                  "
                  @content-ready="addGridNoResults($event)"
                  :selection="{ mode: 'single' }"
                  @exporting="
                    onGridToExcelExporting($event, `Currency`, columns)
                  "
                  :ref="'currency'"
                >
                  <DxExport :enabled="true" />
                  <template #currency-cell-template="{ data }">
                    <!-- GCS-PrimaryRecordCellTemplate -->
                    <GcDescriptionCodeCellTemplate
                      :description="data.data.Description"
                      :code="data.data.CurrencyCode"
                    />
                  </template>
                  <template #active-cell-template="{ data }">
                    <GcInactive :inactive="data.data.Inactive" />
                  </template>

                  <template #RadioTemplate="{ data }">
                    <GcFieldRadio
                      :value="data.data.IsDefault"
                      :data="data"
                      :valueChangeCallBack="radioValueChange"
                      :disabled="data.data.Inactive == 'Y'"
                    />
                  </template>
                </dx-data-grid>
              </template>
              <template #rightContent>
                <gc-advance-filter-panel
                  :toolbar="filterToolbar"
                  :setFilterFormHeight="filterFormHeight"
                  :sideBarTabs="sideBarTabs"
                  :filterFormItems="filterFormItems"
                  :filterModel="getAdvanceFilterModel"
                  :isJson="false"
                  :screenType="'supplier-contact-list'"
                  :data-source-config="dataSourceConfig"
                >
                </gc-advance-filter-panel>
              </template>
            </gc-filter-split-view>
          </div>
        </template>

        <template #rightContent>
          <DxToolbar class="split-view-toolbar">
            <DxItem #default location="before" locate-in-menu="never">
              <div class="toolbar-label">
                <span class="text-primary">{{ model.CurrencyCode }}</span>
              </div>
            </DxItem>
            <DxItem
              widget="dxForm"
              location="after"
              :options="{
                formData: model,
                items: toolbarActiveItems,
                validationGroup: 'toolbarActive',
                labelLocation: 'left',
              }"
              locate-in-menu="after"
              :disabled="baseView.mode == 'review' ? true : false"
            ></DxItem>
            <DxItem
              :options="toolbar.audit"
              location="after"
              locate-in-menu="auto"
              widget="dxButton"
              v-if="baseView.mode == 'review'"
            />
            <DxItem
              :options="toolbar.edit"
              location="after"
              locate-in-menu="auto"
              widget="dxButton"
              :visible="formsConfig.editableOption"
              v-if="baseView.mode == 'review'"
            />
            <DxItem
              :options="toolbar.save"
              location="after"
              locate-in-menu="auto"
              widget="dxButton"
              v-if="baseView.mode != 'review'"
            />
            <DxItem
              :options="toolbar.close"
              location="after"
              widget="dxButton"
            />
          </DxToolbar>
          <div class="view-card responsive-paddings">
            <form>
              <DxForm
                :form-data.sync="model"
                :read-only="false"
                :show-colon-after-label="false"
                :show-required-mark="false"
                :show-validation-summary="false"
                :validation-group="formsConfig.validationGroup"
                :col-count-by-screen="formsConfig.splitViewColCountByScreen"
                label-location="left"
                :customizeItem="customizeItem"
                :items="items"
              ></DxForm>
            </form>
          </div>
        </template>
      </gc-split-view>
    </div>
  </gc-main-layout>
</template>

<script>
import { ForeignCurrencyService } from "../../../_services/api/settings/accounting/foreign-currency.service";
import BaseViewMixin from "../../../v1/_mixins/base.view";
import validationEngine from "devextreme/ui/validation_engine";

export default {
  components: {},
  mixins: [BaseViewMixin],
  updated() {
    if (this.showRightContainer) {
      validationEngine.validateGroup(this.formsConfig.validationGroup);
      validationEngine.validateGroup("toolbarActive");
    }
  },
  created() {
    this.selectedIndex = 0;

    setTimeout(() => {
      if (this.showRightContainer) {
        validationEngine.validateGroup(this.formsConfig.validationGroup);
        validationEngine.validateGroup("toolbarActive");
      }
    }, 250);
  },
  data() {
    return {
      toolbar: {
        close: {
          icon: "close",

          onClick: () => {
            this.$router
              .push({
                path: "/currency",
              })
              .then((res) => {
                if (res)
                  setTimeout(() => {
                    this.reSizeGrid();
                  }, 50);
              });
          },
        },
        edit: {
          icon: "edit",

          onClick: () => {
            this.$router.push({
              path: `/currency/edit/${this.baseView.id}`,
            });
          },
        },
        save: {
          icon: "floppy",
          validationGroup: "formsData",
          onClick: (e) => {
            this.$logger.trackEventButtonClickSave();
            this.saveForeignCurrency(e);
          },
        },
        audit: {
          icon: "clock",
          visible: function() {
            return this.baseView.mode != "create";
          },
          onClick: () => {
            this.displayAuditPopup(
              this.model.CreatedBy,
              this.model.DateCreated,
              this.model.ChangedBy,
              this.model.DateChanged
            );
          },
        },
      },
      model: {
        CurrencyCode: "",
        Description: "",
        BuyRate: 0.0,
        GroupRate: 0.0,
        SellRate: 0.0,
        Active: true,
        CreatedBy: "",
        DateCreated: "",
        ChangedBy: "",
        DateChanged: "",
        IsDefault: true,
        IsDefaultData: false,
      },

      advanceFilterModel: {
        Inactive: "",
      },

      rowSelect: {
        view: this,
        page: "currency",
        mode: "review",
        idProperty: "CurrencyCode",
      },
    };
  },
  computed: {
    items() {
      let formFields = [
        {
          itemType: "group",
          caption: "",
          items: this.parseFormColumns([
            {
              dataField: "CurrencyCode",
              gcLabel: "Currency",
              gcType: "String",
              visible: this.baseView.mode == "create",
              editorOptions: {
                maxLength: 3,
              },
              editorType: "dxTextBox",
              required: true,
            },
            {
              dataField: "Description",
              gcLabel: "Description",
              gcType: "String",
              editorOptions: {
                maxLength: 50,
              },
              editorType: "dxTextBox",
              required: true,
            },
            {
              dataField: "BuyRate",
              gcLabel: "Buy Rate",
              gcType: "Decimal-4-4",
              required: true,
            },
            {
              dataField: "SellRate",
              gcLabel: "Sell Rate",
              gcType: "Decimal-4-4",
              required: true,
            },
            {
              dataField: "GroupRate",
              gcLabel: "Corporate Rate",
              gcType: "Decimal-4-4",
              required: true,
            },
            {
              dataField: "IsDefault",
              gcLabel: "Default",
              gcType: "String",
              editorType: "dxSwitch",
              editorOptions: {
                readOnly:
                  this.model["IsDefaultData"] || !this.model["Active"]
                    ? true
                    : false,
              },
            },
          ]),
        },
      ];

      return formFields;
    },
    getAdvanceFilterModel() {
      return this.advanceFilterModel;
    },
    filterFormItems() {
      return [
        {
          itemType: "group",
          caption: "",
          colCount: 1,
          items: this.parseFormColumns([
            {
              dataField: "Inactive",
              gcType: "String",
              editorType: "dxTagBox",
              gcLabel: "Status",
              editorOptions: {
                items: [
                  {
                    text: "Active",
                    value: "N",
                  },
                  {
                    text: "Inactive",
                    value: "Y",
                  },
                ],
                valueExpr: "value",
                displayExpr: "text",
              },
            },
          ]),
        },
      ];
    },
    columns() {
      return this.parseGridColumns("master", [
        // GCS-PrimaryRecordFixedLeftFirstColumn
        {
          gcLabel: "Currency", // GCS-GcLabel
          dataField: "Description", // GCS-PrimaryRecordSortAndColumn
          cellTemplate: "currency-cell-template", // GCS-PrimaryRecordCellTemplate
          gcType: "String", // GCS-GcType
          gcSubType: "PrimaryRecord",
          gcExport: ["CurrencyCode", "Description"], // GCS-PrimaryRecordExport
        },
        {
          gcLabel: "Buy Rate",
          dataField: "BuyRate",
          gcType: "Decimal-6-4",
        },
        {
          gcLabel: "Sell Rate",
          dataField: "SellRate",
          gcType: "Decimal-6-4",
        },
        {
          gcLabel: "Corporate Rate",
          dataField: "GroupRate",
          gcType: "Decimal-6-4",
        },
        {
          gcType: "String",
          gcSubType: "Chip",
          dataField: "Inactive",
          cellTemplate: "active-cell-template",
        },
        {
          gcLabel: "Currency Code",
          dataField: "CurrencyCode",
          width: 120,
          gcType: "String",
          gcSubType: "HiddenCode", // GCS-PrimaryRecordCodeHidden
        },
        {
          gcLabel: "Description",
          dataField: "Description",
          width: 120,
          gcType: "String",
          gcSubType: "HiddenDescription", // GCS-PrimaryRecordDescriptionHidden
        },
        {
          gcType: "String",
          gcLabel: "Default",
          gcSubType: "IsDefault",
          dataField: "IsDefault",
          width: 75,
          cellTemplate: "RadioTemplate",
        },
      ]);
    },
    toolbarActiveItems() {
      return this.parseFormColumns([
        {
          dataField: "Active",
          gcType: "Boolean",
          gcLabel: "Active",
          editorOptions: {
            readOnly: this.model["IsDefault"] ? true : false,
          },
        },
      ]);
    },
    dataSourceConfig() {
      return ForeignCurrencyService.dataSourceConfig("api/CompanyCurrency", {
        // select: [
        //   "CurrencyCode",
        //   "Description",
        //   "BuyRate",
        //   "SellRate",
        //   "GroupRate",
        //   "Inactive",
        // ],
        // sort: [{ selector: "CurrencyCode", desc: false }], //GCS-NoDataSourceSort
        postProcess: (data) => {
          data.forEach((element) => {
            if (
              element.IsDefault == "Y" &&
              this.baseView.id != element.CurrencyCode
            )
              this.markDefault(false);
          });

          return data;
        },
      });
    },
    // tabs() {
    //   return [
    //     {
    //       text: "Foreign Currency",
    //       path: `/foreign-currency`,
    //       applicationFeatureCode: "CompanyCurrency",
    //     },
    //     {
    //       text: "Tax Category",
    //       path: `/tax-category`,
    //       applicationFeatureCode: "Tax",
    //     },
    //   ];
    // },
    showLeftContainer() {
      return !(this.isXSmall && this.baseView.mode !== "");
    },
    showRightContainer() {
      return !(this.baseView.mode == "review" && this.baseView.id == "");
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler: "handleLocalRouteChange",
    },
  },
  methods: {
    markDefault(value) {
      this.model.IsDefault = value;
    },
    async radioValueChange(cellInfo, event) {
      if (event.value) {
        let grid = this.$refs["currency"].instance;
        var items = grid.getDataSource().items();
        var getDefault,
          clickedDefault = undefined;
        if (items)
          items.forEach((element) => {
            if (element.CurrencyCode == cellInfo.data.CurrencyCode)
              clickedDefault = element.Description;
            if (element.IsDefault == "Y") getDefault = element.Description;
          });
        let confirmDefault = await this.$confirm(
          `Do you want to change the default setting from ${getDefault} to ${clickedDefault} ?`,
          "Default Setting Change"
        );
        if (!confirmDefault) {
          event.component.beginUpdate();
          event.component.option("value", false);
          event.component.endUpdate();
          return;
        }

        this.showLoading(true);
        await ForeignCurrencyService.markAsDefault({
          Code: cellInfo.data.CurrencyCode,
        })
          .then((res) => {
            if (!res) this.showLoading(false);
            let grid = this.$refs["currency"].instance;
            var items = grid.getDataSource().items();
            if (items)
              items.forEach((element) => {
                if (element.CurrencyCode == cellInfo.data.CurrencyCode)
                  element.IsDefault = "Y";
                else element.IsDefault = "N";
              });

            if (
              (this.model.IsDefault &&
                cellInfo.data.CurrencyCode != this.model.CurrencyCode) ||
              (!this.model.IsDefault &&
                cellInfo.data.CurrencyCode == this.model.CurrencyCode)
            )
              this.getFormData();
            else this.showLoading(false);
          })
          .catch((err) => {
            if (err) {
              event.component.beginUpdate();
              event.component.option("value", false);
              event.component.endUpdate();
              this.showLoading(false);
            }
          });
      }
    },
    backButtonFunction() {
      this.$router.push({
        path: "/settings/accounting",
      });
    },
    onToolbarPreparing(e) {
      var toolbarItems = e.toolbarOptions.items;
      var searchPanel = toolbarItems.find((item) => {
        return item.name === "searchPanel";
      });
      var exportButton = toolbarItems.find((item) => {
        return item.name === "exportButton";
      });
      var columnChooserButton = toolbarItems.find((item) => {
        return item.name === "columnChooserButton";
      });

      e.toolbarOptions.items = toolbarItems.filter((item) => {
        return (
          item.name !== "exportButton" &&
          item.name !== "searchPanel" &&
          item.name !== "columnChooserButton"
        );
      });

      searchPanel.location = "after";
      exportButton.location = "after";

      e.toolbarOptions.items.unshift(
        {
          location: "before",
          widget: "dxButton",
          options: {
            icon: "plus",
            text: "Add New",
            onClick: async () => {
              await ForeignCurrencyService.getItems({
                url: "api/CompanyCurrency",
                select: "CurrencyCode,IsDefault",
                filter: "IsDefault eq 'Y'",
                count: true,
              })
                .then((res) => {
                  if (res.data.value.length > 0) this.model.IsDefault = false;
                  else this.model.IsDefault = true;
                })
                .catch((err) => {
                  if (err) this.model.IsDefault = true;
                });
              this.$logger.trackEventButtonClickAddNew();
              this.model.CurrencyCode = "";
              this.model.Description = "";
              this.model.BuyRate = 0.0;
              this.model.SellRate = 0.0;
              this.model.GroupRate = 0.0;
              this.model.Active = true;
              this.model.IsDefaultData = false;
              this.$router.push({
                path: "/currency/create",
              });
            },
          },
        },
        searchPanel,
        exportButton,
        columnChooserButton,
        {
          location: "after",
          locateinmenu: "auto",
          widget: "dxButton",
          options: {
            validationGroup: "formsData",
            icon: "filter",
            elementAttr: { id: "filter-btn" },
            onClick: () => {
              this.showFilterRightContainer = !this.showFilterRightContainer;
              var item = document.getElementById("filter-btn");
              this.$logger.debug("item ", item);
              item.classList.add("dx-state-invisible");
            },
          },
        }
      );
    },
    getFormData() {
      let that = this;
      this.getRecord()
        .then((response) => {
          if (response.data.value.length > 0) {
            this.model.CurrencyCode = response.data.value[0].CurrencyCode;
            this.model.Description = response.data.value[0].Description;
            this.model.BuyRate = response.data.value[0].BuyRate;
            this.model.SellRate = response.data.value[0].SellRate;
            this.model.GroupRate = response.data.value[0].GroupRate;
            this.model.Active = response.data.value[0].Inactive == "N";
            this.model.DateChanged = response.data.value[0].DateChanged;
            this.model.CreatedBy = response.data.value[0].CreatedBy;
            this.model.ChangedBy = response.data.value[0].ChangedBy;
            this.model.DateCreated = response.data.value[0].DateCreated;
            this.model.IsDefault =
              response.data.value[0].IsDefault == "Y" ? true : false;
            this.model.IsDefaultData =
              response.data.value[0].IsDefault == "Y" ? true : false;
            that.refreshView();
            this.showLoading(false);
          }
        })
        .catch((err) => {
          if (err) this.showLoading(false);
        });
    },
    handleLocalRouteChange() {
      if (
        (this.baseView.mode === "review" || this.baseView.mode === "edit") &&
        this.baseView.id
      ) {
        this.model.CurrencyCode = this.baseView.id;
        this.getFormData();
      }
    },
    async getRecord() {
      return ForeignCurrencyService.getByCode(this.baseView.id);
    },
    async saveForeignCurrency(e) {
      const result = await e.validationGroup.validate();
      if (!result.isValid) {
        this.displayValidationSummary();
        return;
      }

      this.showLoading(true);

      await ForeignCurrencyService.save(this.baseView.mode, {
        CurrencyCode: this.model.CurrencyCode,
        Description: this.model.Description,
        BuyRate: this.model.BuyRate,
        SellRate: this.model.SellRate,
        GroupRate: this.model.GroupRate,
        Inactive: this.model.Active ? "N" : "Y",
        IsDefault: this.model.IsDefault ? "Y" : "N",
      })
        // eslint-disable-next-line no-unused-vars
        .then((res) => {
          this.showLoading(false);
          // eslint-disable-next-line no-console
          // this.$logger.debug("saveForeignCurrency", res);
          this.$notify(
            `Currency ${this.model.CurrencyCode} saved successfully`,
            "success"
          );
          this.setIgnoreRouteChangeConfirmation();
          this.$router.push({
            path: `/currency/review/${this.model.CurrencyCode}`,
          });
        })
        .catch((error) => {
          this.displayServerError(error, "Foreign Currency save failed");
        });
    },
  },
};
</script>
